import { createStore } from 'react-sweet-state';

import { actions } from './actions';
import { initialState } from './initialState';
import type { AppConnectionBannerState } from './types';

type Actions = typeof actions;

export const store: ReturnType<typeof createStore<AppConnectionBannerState, Actions>> = createStore<
	AppConnectionBannerState,
	Actions
>({
	initialState,
	actions,
	name: 'app-connection-banner-store',
});
